<p-panel header="Details" class="non-member-information-display-card" data-cy="non-member-information-display-card">
  <div class="non-member-information-card">
    @if (firstPurchase) {
    <p class="consumer-tenure">
      First purchase <b>{{ firstPurchase | date }}</b>
    </p>
    } @if (lifetimeWindow) {
    <div class="consumer-spend-window-header consumer-spend-window-header-lifetime">
      <span class="consumer-spend-window-title">{{ lifetimeWindow.label }}</span>
      <span class="consumer-spend-window-rule"></span>
    </div>
    <div class="consumer-spend-window-group consumer-spend-window-group-lifetime">
      <div class="consumer-loyalty-program-panel-row">
        <label>Total Spend</label>
        <span>{{ lifetimeWindow.totalSpend | currency }}</span>
      </div>
      <div class="consumer-loyalty-program-panel-row">
        <label>Visits</label>
        <span>{{ lifetimeWindow.visits | number }}</span>
      </div>
      <div class="consumer-loyalty-program-panel-row">
        <label>Average Spend</label>
        <span>{{ lifetimeWindow.averageSpend | currency }}</span>
      </div>
      <div class="consumer-loyalty-program-panel-row">
        <label>Visit Frequency</label>
        <span>{{ lifetimeWindow.visitFrequency }}</span>
      </div>
    </div>
    } @else {
    <p class="consumer-spend-window-unavailable">Spend metrics are not available for this customer.</p>
    }
  </div>
</p-panel>
